import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import api from "../lib/api";
import { AUTH_TEXT, authInputCls, authLabelCls, authBtnCls } from "../components/auth/authText";

export default function ForgotPassword() {
  const { lang } = useLang();
  const tx = AUTH_TEXT[lang] || AUTH_TEXT.en;
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email, lang });
      setSent(true);
    } catch (err) {
      setError(err.response?.status === 429 ? tx.tooMany : tx.genericError);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-24 md:py-32" data-testid="forgot-password-page">
      <h1 className="serif text-4xl text-center mb-4">{tx.forgotTitle}</h1>
      {sent ? (
        <p className="text-center text-sm text-[#C9C2B8] leading-7 mt-10" data-testid="forgot-password-sent">{tx.sent}</p>
      ) : (
        <form onSubmit={submit} className="space-y-6 mt-10">
          <p className="text-center text-sm text-[#8A857D] leading-7">{tx.forgotSub}</p>
          <div>
            <label className={authLabelCls}>{tx.email}</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-password-email-input" className={authInputCls} />
          </div>
          {error && <p className="text-sm text-[#E5484D]" data-testid="forgot-password-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="forgot-password-submit-button" className={authBtnCls}>
            {loading ? "…" : tx.sendLink}
          </button>
        </form>
      )}
      <p className="text-center text-sm mt-8">
        <Link to="/login" data-testid="forgot-password-back-to-login" className="text-[#C49A6C] link-underline">{tx.backToLogin}</Link>
      </p>
    </div>
  );
}
